//
//
//
//

export default {
  name: "bandinfo",
  data() {
    return {};
  },
  mounted() {
    this.$vux.alert.show({
      title: "提示",
      content: "您暂未绑定会员账号,请与相关门店人员联系!",
    });
  },
  methods: {},
};



// WEBPACK FOOTER //
// ./src/components/bandinfo.vue